<template lang="html">
    <article class="page">
        <h4>
            <span class="title">{{titles[0]}} > </span>
            <span class="title">{{titles[1]}} </span>
        </h4>
        <slot>

        </slot>
    </article>
</template>

<script>
export default {
    props: ['titles']

}
</script>

<style lang="scss" scoped="true">
.page{
    margin: 30px;
    padding: 24px;
    padding-bottom: 40px;
    background: #fff;
    .title{
        color: #666666;
        font-size: 14px;
    }
    .title:last-child{
        color: #333333;
    }
}
</style>
